import { atom } from '~/observers/jotai'

import { ToastDTO } from './types'

export const toastsAtom = atom<ToastDTO[]>([])
